module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Registro Geral\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-3",
      "label": "RG",
      "field": "rgNumero",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false,
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.rg.numero),
      expression: "cadastrado.pessoa.rg.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rgNumero",
      "id": "rgNumero",
      "data-vv-as": "RG",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.rg.numero)
    },
    on: {
      "focus": _vm.removeMascaraRg,
      "blur": _vm.aplicaMascaraRg,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.rg, "numero", $event.target.value)
      }, _vm.limitaRgInput],
      "change": function($event) {
        return _vm.zeraDataEmissao()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(!_vm.cadastrado.lancamentoPermitido) ? _c('div', [_c('campo-calendario', {
    attrs: {
      "rotulo": "Data da Emissão",
      "nome": "dataEmissao",
      "validacao": {
        required: true
      },
      "disabled": _vm.situacaoRecad === 'CONFIRMADO'
    },
    model: {
      value: (_vm.cadastrado.pessoa.rg.dataEmissao),
      callback: function($$v) {
        _vm.$set(_vm.cadastrado.pessoa.rg, "dataEmissao", $$v)
      },
      expression: "cadastrado.pessoa.rg.dataEmissao"
    }
  })], 1) : _c('div', [_c('label', {
    attrs: {
      "for": "dataEmissao"
    }
  }, [_vm._v("Data da Emissão")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput form-control",
    staticStyle: {
      "background-color": "#eeee",
      "opacity": "1"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.formatarData(_vm.cadastrado.pessoa.rg.dataEmissao)) + "\n                        ")])])]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3",
      "label": "Orgão Emissor",
      "field": "orgaoEmissor",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.rg.orgaoEmissor),
      expression: "cadastrado.pessoa.rg.orgaoEmissor"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:5'),
      expression: "'required|max:5'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "orgaoEmissor",
      "id": "orgaoEmissor",
      "data-vv-as": "Orgão Emissor",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.rg.orgaoEmissor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.rg, "orgaoEmissor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3",
      "label": "Estado Emissor",
      "field": "uf",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.rg.uf),
      expression: "cadastrado.pessoa.rg.uf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "uf",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO',
      "data-vv-as": "Estado Emissor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa.rg, "uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      key: uf.sigla,
      attrs: {
        "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
      },
      domProps: {
        "value": uf.sigla
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("tudoMaiusculo")(uf.nome)) + "\n                        ")])
  })], 2)])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Título de Eleitor")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Título",
      "field": "tituloNumero",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.tituloEleitor.numero),
      expression: "cadastrado.pessoa.tituloEleitor.numero"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('####.####.#####'),
      expression: "'####.####.#####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "tituloNumero",
      "id": "tituloNumero",
      "data-vv-as": "Título",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.tituloEleitor.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.tituloEleitor, "numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3 col-xs-6",
      "label": "Zona",
      "field": "zona",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.tituloEleitor.zona),
      expression: "cadastrado.pessoa.tituloEleitor.zona"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###'),
      expression: "'###'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "zona",
      "id": "zona",
      "data-vv-as": "Zona",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.tituloEleitor.zona)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.tituloEleitor, "zona", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3 col-xs-6",
      "label": "Seção",
      "field": "secao",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.tituloEleitor.secao),
      expression: "cadastrado.pessoa.tituloEleitor.secao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('####'),
      expression: "'####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "secao",
      "id": "secao",
      "data-vv-as": "Seção",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.tituloEleitor.secao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.tituloEleitor, "secao", $event.target.value)
      }
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Trabalhista")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-4",
      "label": "PIS/PASEP",
      "field": "pisPasep",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.pisPasep),
      expression: "cadastrado.pessoa.pisPasep"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.#####.##-#'),
      expression: "'###.#####.##-#'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "pisPasep",
      "id": "pisPasep",
      "data-vv-as": "PIS/PASEP",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.pisPasep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa, "pisPasep", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-4",
      "label": "Orgão de Classe",
      "field": "orgaoClasse",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.orgaoClasse.descricao),
      expression: "cadastrado.pessoa.orgaoClasse.descricao"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:7'),
      expression: "'max:7'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "orgaoClasse",
      "id": "orgaoClasse",
      "data-vv-as": "Orgão de Classe",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.orgaoClasse.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.orgaoClasse, "descricao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-4",
      "label": "Número",
      "field": "numeroOrgao",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.orgaoClasse.numero),
      expression: "cadastrado.pessoa.orgaoClasse.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.temOrgaoClasse,
        max: 10
      }),
      expression: "{ required: temOrgaoClasse, max: 10 }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "numeroOrgao",
      "id": "numeroOrgao",
      "data-vv-as": "Número",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.orgaoClasse.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.orgaoClasse, "numero", $event.target.value)
      }
    }
  })])], 1)])])])]), _vm._v(" "), (_vm.cadastrado.pessoa.motorista) ? _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Carteira de Habilitação")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-4",
      "label": "CNH",
      "field": "numeroCnh",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.cnh.numero),
      expression: "cadastrado.pessoa.cnh.numero"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('############'),
      expression: "'############'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|is_not:0'),
      expression: "'required|is_not:0'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "numeroCnh",
      "id": "numeroCnh",
      "data-vv-as": "CNH",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.cnh.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.cnh, "numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-4 col-xs-6",
      "label": "Categoria",
      "field": "categoria",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.cnh.categoria),
      expression: "cadastrado.pessoa.cnh.categoria"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "categoria",
      "data-vv-as": "Categoria",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa.cnh, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.categorias), function(categoria) {
    return _c('option', {
      key: categoria.id,
      attrs: {
        "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
      },
      domProps: {
        "value": categoria.codigo
      }
    }, [_vm._v("\n                          " + _vm._s(categoria.codigo) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-6"
  }, [_c('campo-calendario', {
    attrs: {
      "rotulo": "Validade",
      "nome": "validadeCnh",
      "data-maxima": _vm.daquiADezAnos,
      "validacao": {
        required: true
      },
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    model: {
      value: (_vm.cadastrado.pessoa.cnh.validade),
      callback: function($$v) {
        _vm.$set(_vm.cadastrado.pessoa.cnh, "validade", $$v)
      },
      expression: "cadastrado.pessoa.cnh.validade"
    }
  })], 1)], 1)])])])]) : _vm._e()])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca(_vm.cadastrado, 'Filiacao')
      }
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19ef9608","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recadastramento/documentacao/index.vue
// module id = giWo
// module chunks = 5